import { render, staticRenderFns } from "./KollekteappEmbed.vue?vue&type=template&id=321c3e1c&"
import script from "./KollekteappEmbed.vue?vue&type=script&lang=js&"
export * from "./KollekteappEmbed.vue?vue&type=script&lang=js&"
import style0 from "./KollekteappEmbed.vue?vue&type=style&index=0&id=321c3e1c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports